import { TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../redux/store";
import { setEventItem, setItem } from "../../redux/Reducers/createPostReducer";
import { styles } from "./CreatePostStyles";
import Section from "./Section";
import { T } from "react-translator-component";

export default function Details() {
  const dispatch = useAppDispatch();

  const createPostType = useSelector((state: any) => state.createPost.createPostType);
  const post = useSelector((state: any) => state.createPost.values);
  const details = post.details;
  const description = post.event.description;
  const error = useSelector((state: any) => state.createPost.errors.details);

  const isEventPost = createPostType === 'GroupEventPost'

  const handleChangeDetails = (value: string) => {
    if (isEventPost) {
      // イベント投稿の場合は、post.detailsとpost_event.descriptionに同等の内容が入っているため
      dispatch(setItem({key: 'details', value: value}))
      dispatch(setEventItem({key: 'description', value: value}))
    } else {
      dispatch(setItem({key: 'details', value: value}))
    }
  }

  return (
    <Section
      title={`${T("details")}${T("required")}`}
      body={
        <TextField
          onChange={(e) => handleChangeDetails(e.target.value)}
          inputProps={{ maxLength: 2500 }}
          sx={ styles.inputField }
          hiddenLabel
          multiline
          value={isEventPost ? description : details}
          rows={7}
          FormHelperTextProps={{ style: styles.errorMessage }}
          error={!!error}
          helperText={error}
        />
      }
    />
  )
}
